import type * as React from 'react'

export function preventDoubleClick<T extends React.MouseEvent>(
  handler?: (event: T) => void
): ((event: T) => void) | undefined {
  if (!handler) return undefined

  return (event) => {
    if (event.detail > 1) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    handler(event)
  }
}
